// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.active-connectors {
  min-height: calc(100vh - 70px);
  background: #f8fafc;
  padding: 40px;
}

.active-connectors-header {
  text-align: center;
  margin-bottom: 40px;
}

.active-connectors-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.active-connectors-header p {
  font-size: 16px;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.connectors-list {
  max-width: 1000px;
  margin: 0 auto 40px;
}

.connector-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.connector-main {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}

.connector-avatar {
  flex-shrink: 0;
}

.avatar-circle {
  width: 48px;
  height: 48px;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
}

.connector-content {
  flex: 1 1;
}

.connector-title {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.connector-title h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.platform-logos {
  display: flex;
  align-items: center;
  gap: 8px;
}

.platform-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.sync-arrows {
  color: #6b7280;
}

.connector-description {
  margin-bottom: 16px;
}

.connector-description p {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0;
}

.connector-stats {
  display: flex;
  gap: 32px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-label {
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
}

.stat-value {
  font-size: 14px;
  color: #1f2937;
  font-weight: 600;
}

.connector-controls {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 16px;
}

.sync-status {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sync-status-text {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
}

.toggle-switch {
  position: relative;
}

.toggle-switch input[type="checkbox"] {
  display: none;
}

.toggle-label {
  display: block;
  width: 44px;
  height: 24px;
  background: #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
}

.toggle-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 48px;
  height: 23px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.toggle-switch input[type="checkbox"]:checked + .toggle-label {
  background: #10b981;
}

.toggle-switch input[type="checkbox"]:checked + .toggle-label .toggle-slider {
  transform: translateX(20px);
}

.connector-actions {
  display: flex;
  gap: 8px;
}

.edit-button,
.settings-button {
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  background: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  color: #6b7280;
}

.edit-button:hover,
.settings-button:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
}

.connectors-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 1000px;
  margin: 0 auto;
}

.cancel-button,
.continue-button {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid;
}

.cancel-button {
  background: white;
  color: #6b7280;
  border-color: #d1d5db;
}

.cancel-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.continue-button {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.continue-button:hover {
  background: #2563eb;
  border-color: #2563eb;
}

@media (max-width: 768px) {
  .active-connectors {
    padding: 20px;
  }

  .connector-main {
    flex-direction: column;
    gap: 16px;
  }

  .connector-controls {
    align-items: flex-start;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }

  .connector-stats {
    flex-direction: column;
    gap: 12px;
  }

  .connectors-actions {
    flex-direction: column;
  }

  .cancel-button,
  .continue-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/ActiveConnectors.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".active-connectors {\n  min-height: calc(100vh - 70px);\n  background: #f8fafc;\n  padding: 40px;\n}\n\n.active-connectors-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.active-connectors-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.active-connectors-header p {\n  font-size: 16px;\n  color: #6b7280;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.connectors-list {\n  max-width: 1000px;\n  margin: 0 auto 40px;\n}\n\n.connector-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.connector-main {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.connector-avatar {\n  flex-shrink: 0;\n}\n\n.avatar-circle {\n  width: 48px;\n  height: 48px;\n  background: #f3f4f6;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n}\n\n.connector-content {\n  flex: 1;\n}\n\n.connector-title {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.connector-title h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.platform-logos {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.platform-logo {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.sync-arrows {\n  color: #6b7280;\n}\n\n.connector-description {\n  margin-bottom: 16px;\n}\n\n.connector-description p {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.connector-stats {\n  display: flex;\n  gap: 32px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #9ca3af;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 14px;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.connector-controls {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 16px;\n}\n\n.sync-status {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.sync-status-text {\n  font-size: 12px;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n.toggle-switch {\n  position: relative;\n}\n\n.toggle-switch input[type=\"checkbox\"] {\n  display: none;\n}\n\n.toggle-label {\n  display: block;\n  width: 44px;\n  height: 24px;\n  background: #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  position: relative;\n}\n\n.toggle-slider {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 48px;\n  height: 23px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-switch input[type=\"checkbox\"]:checked + .toggle-label {\n  background: #10b981;\n}\n\n.toggle-switch input[type=\"checkbox\"]:checked + .toggle-label .toggle-slider {\n  transform: translateX(20px);\n}\n\n.connector-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.edit-button,\n.settings-button {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e5e7eb;\n  background: white;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  color: #6b7280;\n}\n\n.edit-button:hover,\n.settings-button:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n  color: #374151;\n}\n\n.connectors-actions {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.cancel-button,\n.continue-button {\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid;\n}\n\n.cancel-button {\n  background: white;\n  color: #6b7280;\n  border-color: #d1d5db;\n}\n\n.cancel-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.continue-button {\n  background: #3b82f6;\n  color: white;\n  border-color: #3b82f6;\n}\n\n.continue-button:hover {\n  background: #2563eb;\n  border-color: #2563eb;\n}\n\n@media (max-width: 768px) {\n  .active-connectors {\n    padding: 20px;\n  }\n\n  .connector-main {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .connector-controls {\n    align-items: flex-start;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .connector-stats {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .connectors-actions {\n    flex-direction: column;\n  }\n\n  .cancel-button,\n  .continue-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
